import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import { AccountCircleOutlined } from "@mui/icons-material";
import { IconButtonProps, Menu } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { logout } from "../../store/backofficeUser/actions";
import { Link, useNavigate } from "react-router-dom";
import { userHasRole } from "../../services/backofficeUserService";
import { Roles } from "../../types/BackofficeUser";
import { useCurrentUser } from "../../provider/CurrentUserProvider";
import { useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../services/ReactQuery/reactQueryService";
import { navigationBarAccountMenuStyle } from "./navigationBarAccountMenuStyle";

const NavigationBarAccountMenu = () => {
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement>();
  const navigate = useNavigate();
  const currentUser = useCurrentUser();
  const queryClient = useQueryClient();

  const handleButtonClick: IconButtonProps["onClick"] = (event) => {
    setAnchorEl(event.currentTarget);
    setAccountMenuOpen(true);
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const clearImpersonate = () => {
    sessionStorage.removeItem("impersonate");
    queryClient.invalidateQueries({
      queryKey: queryKeys.all("current_user")
    }).then(() => navigate("/"));
  };

  return (
    <>
      <IconButton onClick={handleButtonClick} size="large">
        <AccountCircleOutlined sx={navigationBarAccountMenuStyle.loginIcon} />
      </IconButton>
      <Menu
        open={accountMenuOpen}
        onClose={() => setAccountMenuOpen(false)}
        anchorEl={anchorEl}
        slotProps={{ root: { disableScrollLock: true } }}
      >
        {!userHasRole(currentUser, Roles.callcenter) && (
          <MenuItem
            component={Link}
            to={"/services" + (userHasRole(currentUser, Roles.external) ? "/extern" : "") + "/mein-konto"}
            onClick={() => setAccountMenuOpen(false)}
          >
            Mein Konto
          </MenuItem>
        )}
        <MenuItem component={Link} to={"/services/notifications"} onClick={() => setAccountMenuOpen(false)}>
          Benachrichtigungen
        </MenuItem>
        <MenuItem onClick={handleLogout}>Abmelden</MenuItem>
        {!!sessionStorage.getItem("impersonate") && (
          <MenuItem onClick={clearImpersonate}>Benutzeransicht beenden</MenuItem>
        )}
      </Menu>
    </>
  );
};

export default NavigationBarAccountMenu;
